import React, { useContext, useState } from "react";
import Button from "@mui/material/Button";
import BaseApi from "../../../../functions/axios";
import { globalContext } from "../../../../App";

export default function PersonnelHiddenButton({ matchingId, sx, ...props }) {
  const { setRerendering, rerendering } = useContext(globalContext);
  const [loading, setLoading] = useState(false);

  const handleClick = async (event) => {
    event.stopPropagation();
    if (loading) return;
    setLoading(true);
    try {
      await BaseApi.post("close_matching", { matching_id: matchingId });
      setRerendering(!rerendering);
    } catch (error) {
      console.error("close_matching error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="contained"
      disabled={loading}
      sx={{
        color: "white",
        fontSize: "14px",
        marginTop: "20px",
        fontWeight: "bold",
        width: "120px",
        borderRadius: "25px",
        backgroundColor: "#28345e",
        "&:hover": {
          background: "#8bb6c6",
        },
        ...sx,
      }}
      onClick={handleClick}
      {...props}
    >
      要員を非表示
    </Button>
  );
}